module.exports = __webpack_public_path__ + "img/jd23_22_trailer.66a9824e.jpg";